const VERSION_TYPE = {
    original: 'ORIGINAL',
    appendix: 'APPENDIX',
    digitization: 'DIGITIZATION',
    inflationAdjustment: 'INFLATION_ADJUSTMENT',
    valorizationAdjustment: 'VALORIZATION_ADJUSTMENT',
    automaticReprice: 'AUTOMATIC_REPRICE',
    automaticInflationIncrease: 'AUTOMATIC_INFLATION_INCREASE',
    automaticRepriceAndInflationIncrease: 'AUTOMATIC_REPRICE_AND_INFLATION_INCREASE',
    automaticValorization: 'AUTOMATIC_VALORIZATION',
    reprice: 'REPRICE',
    other: 'OTHER',
}

export default VERSION_TYPE